import { NavLink } from 'react-router-dom';
import { Building2, Users, Tags, CalendarCheck, FileText, ListTodo, Sparkles, Briefcase } from 'lucide-react';
import { FaCalendarDays } from '../ui/FaIcons';
import { cn } from '../../lib/cn';

const SETTINGS_TABS = [
  { slug: 'cabinet', label: 'Cabinet', icon: Building2 },
  { slug: 'equipe', label: 'Équipe', icon: Users },
  { slug: 'demandes', label: 'Demandes', icon: Tags },
  { slug: 'taches', label: 'Tâches', icon: ListTodo },
  { slug: 'dossiers', label: 'Dossiers', icon: Briefcase },
  { slug: 'agenda', label: 'Agenda', icon: FaCalendarDays },
  { slug: 'modeles', label: 'Modèles', icon: FileText },
  { slug: 'integrations', label: 'Intégrations', icon: CalendarCheck },
  { slug: 'agent', label: 'Agent IA', icon: Sparkles },
] as const;

export function SettingsTabNav() {
  return (
    <nav aria-label="Onglets des paramètres">
      <ul className="flex flex-wrap gap-1">
        {SETTINGS_TABS.map(({ slug, label, icon: Icon }) => (
          <li key={slug}>
            <NavLink
              to={`/parametres/${slug}`}
              className={({ isActive }) =>
                cn(
                  'inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium leading-none transition-all duration-300 ease',
                  isActive
                    ? 'bg-cime-gold text-cime-primary hover:bg-cime-gold'
                    : 'bg-cime-sidebar-bg text-white hover:bg-[color-mix(in_srgb,var(--cime-primary)_72%,white)] hover:text-white',
                )
              }
            >
              <Icon className="w-3.5 h-3.5 shrink-0" aria-hidden />
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
